<!--
  PendingAccountBanner — shown across the employer shell whenever the current
  session is authenticated but IsApproved = false. Reads state from the Pinia
  employerSession store so it can appear consistently on every child route.

  Copy is the user's official waiting message: account under review, profile
  editing is allowed while waiting, email will arrive on approval.
-->
<script setup lang="ts">
import { computed } from 'vue';
import { useEmployerSessionStore } from '@/stores/employerSession';

const session = useEmployerSessionStore();
const show = computed(() => session.needsApproval);
</script>

<template>
    <div v-if="show" class="jb-pending-banner" role="status">
        <div class="jb-pending-banner__icon" aria-hidden="true">
            <Icon name="clock" :size="20" />
        </div>
        <div class="jb-pending-banner__body">
            <strong>Your account is under review.</strong>
            You can set up your company profile while we take a look. We'll email you the moment you're approved to post listings.
        </div>
    </div>
</template>

<style scoped>
/* Matches the .emp-attention-banner pattern from employer.css — warning-tinted
   fill using var(--jb-warning-rgb) tokens so the palette stays centralized. */
.jb-pending-banner {
    display: flex;
    align-items: center;
    gap: 12px;
    margin: 16px auto;
    padding: 12px 16px;
    max-width: 1200px;
    background: rgba(var(--jb-warning-rgb), 0.08);
    border: 1px solid rgba(var(--jb-warning-rgb), 0.25);
    border-radius: var(--jb-radius);
    color: var(--jb-ink);
    font-size: 14px;
    line-height: 1.45;
}
.jb-pending-banner__icon {
    display: inline-flex;
    color: var(--jb-warning);
    flex-shrink: 0;
}
.jb-pending-banner__body strong {
    margin-right: 6px;
}
</style>
